export default function Footer() {
  return (
    <footer className="bg-navy text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-2 mb-6">
              <div className="w-10 h-10 flex items-center justify-center">
                <i className="ri-home-heart-line text-3xl text-white"></i>
              </div>
              <span className="text-xl font-bold">Loans with Heena</span>
            </div>
            <div className="space-y-2 text-gray-300 text-sm">
              <p>NMLS #123456</p>
              <p>Licensed in CA, TX, FL</p>
              <p>Equal Housing Lender</p>
            </div>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-wider text-gray-400 mb-6">Stay Informed</h4>
            <div className="mb-4">
              <div className="flex items-center border-b border-gray-600 pb-2">
                <input
                  type="email"
                  placeholder="Your email address"
                  className="bg-transparent flex-1 outline-none text-white placeholder-gray-400 text-sm"
                />
                <button className="text-teal hover:text-teal-light transition-colors cursor-pointer">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xl"></i>
                  </div>
                </button>
              </div>
            </div>
            <p className="text-xs text-gray-400">Rate updates & market insights</p>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-wider text-gray-400 mb-6">Quick Links</h4>
            <div className="space-y-4">
              <a href="#programs" className="block text-white hover:text-teal transition-colors cursor-pointer">
                Loan Programs
              </a>
              <a href="#calculator" className="block text-white hover:text-teal transition-colors cursor-pointer">
                Rate Calculator
              </a>
              <a href="#resources" className="block text-white hover:text-teal transition-colors cursor-pointer">
                Resources
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-wider text-gray-400 mb-6">Connect</h4>
            <div className="space-y-4">
              <a href="#linkedin" className="block text-white hover:text-teal transition-colors cursor-pointer">
                LinkedIn
              </a>
              <a href="#facebook" className="block text-white hover:text-teal transition-colors cursor-pointer">
                Facebook
              </a>
              <a href="mailto:contact@example.com" className="block text-white hover:text-teal transition-colors cursor-pointer">
                Email Me
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-cream-dark py-12">
        <div className="max-w-7xl mx-auto px-6">
          <h3 className="text-5xl md:text-6xl font-bold text-center tracking-tight text-gray-800">
            HOME FINANCING MADE SIMPLE
          </h3>
        </div>
      </div>

      <div className="bg-navy-light py-6">
        <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
          <p>© 2025 Loans with Heena. All rights reserved.</p>
          <div className="flex gap-6">
            <a href="#privacy" className="hover:text-white transition-colors cursor-pointer">
              Privacy Policy
            </a>
            <a href="#terms" className="hover:text-white transition-colors cursor-pointer">
              Terms of Service
            </a>
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer">
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}